<div class="cont">



<div class="sectionhead">
  <img src="/assets/icons/trakkicons-05.png" />
  <h1 [translate]>Page.Labels.ASSETS</h1>
</div>



<div class="accordion"><div class="rowww">Section 1</div></div>
<div class="accbody">
  <div class="boxs">
      <p><b>AssetId</b></p>
  </div>
  <div class="boxs">
      <p><b>CreatedOn (date)</b></p>
  </div>
  <div class="boxs">
      <p><b>Name</b></p>
  </div>
  <div class="boxs">
      <p><b>isActive (true/false)</b></p>
  </div>
  <div class="boxs">
      <p><b>ValueData</b></p>
  </div>
  <div class="boxs">
      <p><b>Icon (Id, Name, Url)</b></p>
  </div>
  <div class="boxs">
      <p><b>Events (AssetEventId, AssetId, Date, GeocodedPosition, Lat/Long, ValueData, Comment)</b></p>
  </div>

</div>

<div class="accordion">Section 2</div>
<div class="accbody">
  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
</div>

<div class="accordion">Section 3</div>
<div class="accbody">
  <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
</div>



</div>
